import { render, staticRenderFns } from "./postManagement.vue?vue&type=template&id=311682a2&scoped=true&"
import script from "./postManagement.vue?vue&type=script&lang=js&"
export * from "./postManagement.vue?vue&type=script&lang=js&"
import style0 from "./postManagement.vue?vue&type=style&index=0&id=311682a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311682a2",
  null
  
)

export default component.exports